import axios from "axios";
import { BASE_URL, PRODUCT_DETAILS_URL } from "@/utils/api/Urls";

/**
 * Fetches product details from the server based on the provided product ID.
 * @param id The ID of the product to fetch.
 * @returns The product details of the specified product.
 */
export const fetchProductById = async (id: number) => {
  const requestURL = `${BASE_URL}${PRODUCT_DETAILS_URL}?Id=${id}`;

  try {
    const response = await axios.get(requestURL);
    return response.data as IProductDetails;
  } catch (err: unknown) {
    // Axios error
    if (axios.isAxiosError(err)) {
      // The request was made and the server responded with a status code
      if (err.response) {
        console.log("Error status:", err.response.status);
        return;
      }

      // The request was made but no response was received
      if (err.request) {
        console.log("No response received from server:", err.request);
        return;
      }
    }

    // Non-Axios error
    console.log("Non-Axios error occurred:", err);
  }
};
